

















import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import { ICustomStylingClass } from '@/components/Globals/types/custom.t';

@Component
export default class CustomImage extends Vue {

  @Prop()
  alt?: string;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop({required: true })
  src!: string;

  @Prop()
  keyAlt?: string;

  @Prop()
  keyTitle?: string;

  @Prop()
  width?: string;

  @Prop()
  height?: string;

  @Prop()
  srcset?: string[];

  @Prop()
  loading?: 'lazy' | 'eager';

  @Prop()
  objectFit?:
    | 'contain'
    | 'cover'
    | 'fill'
    | 'none'
    | 'scale-down';

  get translations() {
    return this.$store.state.translations.data;
  }

  @Emit('load')
  load() {}
}

